import "./StainlessSteelGradeSelection.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SelectionHero from "./sections/SelectionHero";
import AlloySelection from "./sections/AlloySelection";
import RelatedArticles from "./sections/RelatedArticles";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function StainlessSteelGradeSelectionPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="StainlessSteelGradeSelection" />
      <SelectionHero />
      <AlloySelection />
      <RelatedArticles />
      <Quote />
      <Footer />
    </div>;
}